const logo = { width: 240, height: 240 };
const menuStack = { px: 8 };
const menuPaperView = {
  height: 150,
  width: 180,
  margin: 2,
  boxShadow: '0 0 13px 0 rgb(0 0 0 / 10%)',
  '&:hover': {
    cursor: 'pointer',
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
  },
};

const menuIcon = { fontSize: 38 };
const styles = {
  logo,
  menuStack,
  menuPaperView,
  menuIcon,
  root: {
    position: 'relative',
    margin: 20,
  },
  slide: {
    padding: 15,
    minHeight: 300,
    color: '#fff',
    textAlign: 'center',
    fontSize: 30,
  },
  slide1: {
    backgroundColor: '#FEA900',
  },
  slide2: {
    backgroundColor: '#B3DC4A',
  },
  slide3: {
    backgroundColor: '#6AC0FF',
  },
};

export { styles };
